import { defaultColors } from '../../Services/contexts/ServicesChartsDataContext';
import { coresFigma } from '../../styles/colors';

export const useHistogram = ({ values, subtitles, horizontal, color }) => {
    const formattedCategories = (subtitles || []).map((val, index) => {
        if (index === 0 || index === subtitles.length - 1) {
            return val.toLocaleString('pt-BR');
        }
        return '';
    });

    const chartConfig = {
        series: [
            {
                name: 'Total',
                data: values || []
            }
        ],
        options: {
            chart: {
                type: 'bar',
                height: 200,
                toolbar: {
                    show: true
                }
            },
            plotOptions: {
                bar: {
                    columnWidth: '100%'
                }
            },
            stroke: {
                width: 0,
                colors: ['#fff']
            },
            dataLabels: {
                enabled: false
            },
            xaxis: {
                categories: formattedCategories,
                labels: {
                    formatter: (val) => val
                }
            },
            yaxis: {
                labels: {
                    formatter: (val) => `${val.toLocaleString('pt-BR')}`
                }
            },
            fill: {
                opacity: 1,
                colors: defaultColors
            },
            tooltip: {
                y: {
                    formatter: (val) => `${val.toLocaleString('pt-BR')}`
                }
            },
            grid: {
                show: false
            }
        }
    };

    return {
        chartConfig
    };
};
